<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

    </div>

    <van-collapse v-model="activeNames">
      <van-field v-model="inputForm.fileCode" label="文件编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.responsiblePerson" label="责任者" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.fileCategory" label="文件类别" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.fileTitle" label="文件材料题名" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.fileDate" label="日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.pageRange" label="页次" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.fileStatusLabel" label="文件状态" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.fileFormatLabel" label="文件形式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.sortOrder" label="排序" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.catalogTypeLabel" label="目录类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
        <p style="color: #AAA">附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
    </van-collapse>
  </div>
</template>

<script>
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "ArmsRegArchiveFilingInfoFile",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      filingInfoId: '',
      url: '',
    }
  },
  components: {
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.filingInfoId = query.filingInfoId
    this.url = query.archiveType === '1' ? '/arms/reg/armsRegArchiveFilingInfoFile/company/queryById' : '/arms/reg/armsRegArchiveFilingInfoFile/dept/queryById'
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryByParams({
        id: id,
        filingInfoId: this.filingInfoId
      }, this.url).then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.getDict([
          ['arms_archive_file_status', 'fileStatus'],
          ['arms_filing_file_format', 'fileFormat'],
          ['arms_filing_file_catalog_type', 'catalogType']
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        })
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      this.$router.back()
    },
  }
}
</script>

<style scoped>

</style>
